
  import {init as runtimeInit, loadRemote} from "@module-federation/runtime";
  
  import exposesMap from "virtual:mf-exposes:wmg1-container__remoteEntry-_hash_"
  import {usedShared, usedRemotes} from "/home/runner/work/wmg2-one-app/wmg2-one-app/container/.__mf__temp/wmg1_mf_2_container/localSharedImportMap"
  import {
    initResolve
  } from "__mf__virtual/wmg1_mf_2_container__mf_v__runtimeInit__mf_v__.js"
  const initTokens = {}
  const shareScopeName = "default"
  const mfName = "wmg1-container"
  async function init(shared = {}, initScope = []) {
    const initRes = runtimeInit({
      name: mfName,
      remotes: usedRemotes,
      shared: usedShared,
      plugins: [],
      shareStrategy: 'loaded-first'
    });
    // handling circular init calls
    var initToken = initTokens[shareScopeName];
    if (!initToken)
      initToken = initTokens[shareScopeName] = { from: mfName };
    if (initScope.indexOf(initToken) >= 0) return;
    initScope.push(initToken);
    initRes.initShareScopeMap('default', shared);
    initResolve(initRes)
    try {
      await Promise.all(await initRes.initializeSharing('default', {
        strategy: 'loaded-first',
        from: "build",
        initScope
      }));
    } catch (e) {
      console.error(e)
    }
    return initRes
  }

  function getExposes(moduleName) {
    if (!(moduleName in exposesMap)) throw new Error(`Module ${moduleName} does not exist in container.`)
    return (exposesMap[moduleName])().then(res => () => res)
  }
  export {
      init,
      getExposes as get
  }
  